export const DELIVERY_VARIATION_KEY = 'deliveryVariationId';
export const SELECTED_SURFACE_KEY = 'selectedSurface';
